import Vue from 'vue'
import Chat from 'vue-beautiful-chat'

Vue.use(Chat)
